import * as Yup from 'yup';

import CustomerList from './Components/CustomerList'

const headers = [
  {
    label: 'Name',
    id: 'name'
  },
  {
    label: 'Description',
    id: 'description'
  },
  {
    label: 'Num of Contacts',
    id: 'num_of_contacts'
  },
  {
    label: "Active",
    id: "is_active",
    boolean: true,
    values: ["Active", "Inactive"]
  }
];


const filters = [
  {
    id: "is_active",
    type: "boolean",
    label: "Active",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "name",
    label: "Group Name",
    type: "text",
    size: {xs: 12},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "description",
    label: "Description",
    type: "text",
    multiline: true,
    rows: 4,
    size: {xs: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "is_active",
    label: "Active",
    type: "checkbox",
    size: {xs: 12, lg: 4},
  },
  {
    fieldType: "divider",
    header: "Contacts",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <CustomerList />,
    name: "customer_list",
    size: {xs: 12},
  }
]

const initialValues = {
  name: "",
  description: "",
  is_active: true
}

const additionalState = {
  contacts: []
}

const schema = Yup.object().shape({
  name: Yup.string().min(1).max(50).required(),
  description: Yup.string().nullable(),
  is_active: Yup.boolean()
});

export { headers, filters, fields, schema, initialValues, additionalState };